import { useSearchParams } from 'next/navigation'
import { SyntheticEvent, useEffect, useState } from 'react'

import { If } from '@src/quince-components/src/atoms/conditionals'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { getSanitizedHtml } from '@src/quince-site-common/src/utils/getSanitizedHtml'
import validateEmail from '@src/quince-site-common/src/utils/validateEmail'

import FormHeader from '../../../../../components/Auth/FormHeader'
import Button from '../../../../../components/Button'
import { BoxStyledErrorMessage } from '../../../../../components/FormElements'
import { StyledVerificationMessage } from '../../../../../components/FormElements/StyledVerificationMessage'
import { GoogleSignIn } from '../../../../Auth/GoogleSignIn/GoogleSignIn'
import { ContinueButton } from '../../../../LogIn/Components/ContinueButton'
import { Email } from '../../../../LogIn/Components/Email'
import styles from '../../../../LogIn/Components/loginComponents.module.scss'
import { TnC } from '../../../../LogIn/Components/TnC'
import useForm from '../../../../LogIn/hook/useForm'

import newStyles from './initialPage.module.scss'
import { getlbUserId } from '@src/quince-site-common/src/utils/getlb-user-id'

interface InitialPagePropTypes {
  serverError?: { message: string }
  unverifiedAccount?: boolean
  resendVerificationEmail: (email?: string) => void
  verificationEmailSent?: boolean
  onGoogleLogIn: (user: any) => void
  email?: string
  loading?: boolean
  onPageStateChange: (email: string) => void
}

const InitialPage = ({
  serverError,
  unverifiedAccount,
  resendVerificationEmail,
  verificationEmailSent,
  email,
  onGoogleLogIn,
  loading,
  onPageStateChange,
}: InitialPagePropTypes) => {
  const deviceInfo = useDeviceInfo()
  const [errors, setErrors] = useState({})
  const isDesktop = deviceInfo.deviceType === DEVICE_TYPES.DESKTOP
  const { email: userEmail, onEmailChange } = useForm({ email })
  const searchParams = useSearchParams()
  const [fromAction, setFromAction] = useState('')
  useEffect(() => {
    setFromAction(localStorage?.getItem('fromAction') ?? searchParams.get('from') ?? '')
  }, [searchParams])
  const onInitialPageSubmit = (e: SyntheticEvent) => {
    e.preventDefault()
    let error = ''
    if (!userEmail) {
      error = 'Please fill in the Email'
    } else if (!validateEmail(userEmail)) {
      error = 'Please enter valid email address'
    }
    if (error) {
      setErrors({
        username: {
          message: error,
        },
      })
    } else {
      onPageStateChange(userEmail)
    }
  }

  return (
    <form onSubmit={onInitialPageSubmit} id="login-form-A-Initial" noValidate>
      <FormHeader>
        <div className={styles.formHeading}>SIGN IN / REGISTER</div>
        {fromAction && <div className={styles.formHeading}>TO MANAGE YOUR ORDER</div>}
        {!fromAction && (
          <div className={styles.formSubHeading}>
            Free shipping, 365-day returns, exclusive benefits, and savings on future orders.
          </div>
        )}
        {fromAction && (
          <div className={styles.formSubHeading}>
            Please sign in or register to track, manage, or return—and unlock more insider benefits.Please sign in or
            register to track, manage, or return—and unlock more insider benefits.
          </div>
        )}
      </FormHeader>
      {serverError && (
        <BoxStyledErrorMessage dangerouslySetInnerHTML={{ __html: getSanitizedHtml(serverError.message) }} />
      )}
      {unverifiedAccount && (
        <StyledVerificationMessage>
          cannot find verification mail?
          <Button
            onClick={() => {
              resendVerificationEmail(email)
            }}
            trackParams={{
              trackInternal: true,
              category: 'login',
              action: 'account_login_unverified',
              context: {
                login_email: email || '',
                lb_user_id: getlbUserId(),
              },
            }}
            className={styles.unVerifiedMessage}
          >
            resend one
          </Button>
        </StyledVerificationMessage>
      )}
      {verificationEmailSent && <StyledVerificationMessage>Verification E-mail Sent!</StyledVerificationMessage>}
      <GoogleSignIn onLoginCompletion={onGoogleLogIn} />
      <div className={styles.divider}>OR</div>
      <Email errors={errors} defaultValue={email} value={userEmail} onChange={onEmailChange} />
      <ContinueButton loading={loading} form="login-form-A-Initial" />
      <If condition={isDesktop}>
        <div className={newStyles.footer}>
          <TnC />
        </div>
      </If>
    </form>
  )
}

export { InitialPage }
